import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectModule} from 'primeng/select';
import {ILanguage} from '../language';

@Component({
  selector: 'app-language-flag-select',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule],
  templateUrl: './language-flag-select.component.html',
  styleUrl: './language-flag-select.component.scss',
})
export class LanguageFlagSelectComponent {
  readonly flagBasePath = 'assets/i18n/flags/';

  @Input({required: true}) languages: ILanguage[] = [];
  @Input({required: true}) selectedValue!: string;
  @Output() selectedValueChange = new EventEmitter<string>();

  onValueChange(value: string): void {
    this.selectedValueChange.emit(value);
  }

  getFlagPath(language?: ILanguage): string {
    return language?.flag ? `${this.flagBasePath}${language.flag}` : '';
  }
}
